import type { ItemConfig, ExpireRate, FertilizerRate } from '@/common/types/item.types'

export const expireRate: ExpireRate = {"1103011": 0.003, "1103022": 0.005, "1103033": 0.01, "1103041": 0.03,"1103052": 0.015, "1103063": 0.015, "1103074": 0.015, "1103083": 0.001, "1103094": 0.02} as const

export const fertilizerRate: FertilizerRate = {"1103011": 1, "1103022": 3, "1103033": 2, "1103041": 1,"1103052": 2, "1103063": 3, "1103074": 5, "1103083": 3, "1103094": 5} as const

export const itemConfig: Record<string, ItemConfig> = {
    "1101011": {
        "id": "1101011",
        "weight": 2,
        "price": 1,
        "value": 1
    },
    "1101021": {
        "id": "1101021",
        "weight": 2,
        "price": 1,
        "value": 1
    },
    "1101031": {
        "id": "1101031",
        "weight": 1,
        "price": 1,
        "value": 1
    },
    "1101041": {
        "id": "1101041",
        "weight": 1,
        "price": 1,
        "value": 1
    },
    "1101051": {
        "id": "1101051",
        "weight": 1,
        "price": 1,
        "value": 1
    },
    "1101061": {
        "id": "1101061",
        "weight": 1,
        "price": 0.25,
        "value": 0.28279166666666666
    },
    "1101071": {
        "id": "1101071",
        "weight": 4,
        "price": 1.5,
        "value": 1.5
    },
    "1101073": {
        "id": "1101073",
        "weight": 2,
        "price": 6,
        "value": 6
    },
    "1101081": {
        "id": "1101081",
        "weight": 1,
        "price": 0.2,
        "value": 0.2
    },
    "1102011": {
        "id": "1102011",
        "weight": 1,
        "price": 1,
        "value": 1
    },
    "1102022": {
        "id": "1102022",
        "weight": 2,
        "price": 2,
        "value": 2
    },
    "1102033": {
        "id": "1102033",
        "weight": 3,
        "price": 3,
        "value": 3
    },
    "1102042": {
        "id": "1102042",
        "weight": 2,
        "price": 2,
        "value": 2
    },
    "1102053": {
        "id": "1102053",
        "weight": 6,
        "price": 50,
        "value": 50
    },
    "1102063": {
        "id": "1102063",
        "weight": 10,
        "price": 60,
        "value": 60
    },
    "1102073": {
        "id": "1102073",
        "weight": 8,
        "price": 0,
        "value": 0
    },
    "1103011": {
        "id": "1103011",
        "weight": 1,
        "price": 0.75,
        "value": 0.7870296328125,
        "effect_food": {
            "id": "1103011",
            "starve": 10,
            "starve_chance": 1,
            "infect": 10,
            "infect_chance": 0.6
        }
    },
    "1103022": {
        "id": "1103022",
        "weight": 2,
        "price": 5.25,
        "value": 5.056622518148437,
        "effect_food": {
            "id": "1103022",
            "starve": 35,
            "starve_chance": 1
        }
    },
    "1103033": {
        "id": "1103033",
        "weight": 2,
        "price": 4,
        "value": 3.7864089743437495,
        "effect_food": {
            "id": "1103033",
            "starve": 35,
            "starve_chance": 1
        }
    },
    "1103041": {
        "id": "1103041",
        "weight": 1,
        "price": 1,
        "value": 1.1254523749218752,
        "effect_food": {
            "id": "1103041",
            "starve": 14,
            "starve_chance": 1,
            "infect": 20,
            "infect_chance": 0.9
        }
    },
    "1103052": {
        "id": "1103052",
        "weight": 2,
        "price": 4.5,
        "value": 4.45138906415578,
        "effect_food": {
            "id": "1103052",
            "starve": 40,
            "starve_chance": 1
        }
    },
    "1103063": {
        "id": "1103063",
        "weight": 2,
        "price": 5.75,
        "value": 5.666187600476133,
        "effect_food": {
            "id": "1103063",
            "starve": 40,
            "starve_chance": 1
        }
    },
    "1103074": {
        "id": "1103074",
        "weight": 3,
        "price": 12,
        "value": 11.30843054871349,
        "effect_food": {
            "id": "1103074",
            "spirit": 30,
            "spirit_chance": 1,
            "starve": 80,
            "starve_chance": 1
        }
    },
    "1103083": {
        "id": "1103083",
        "weight": 2,
        "price": 5,
        "value": 5,
        "effect_food": {
            "id": "1103083",
            "starve": 40,
            "starve_chance": 1
        }
    },
    "1103094": {
        "id": "1103094",
        "weight": 1,
        "price": 14,
        "value": 13.20843054871349,
        "effect_food": {
            "id": "1103074",
            "spirit": 80,
            "spirit_chance": 1,
            "starve": 30,
            "starve_chance": 1
        }
    },
    "1104011": {
        "id": "1104011",
        "weight": 1,
        "price": 21.5,
        "value": 21.05608633968867,
        "effect_medicine": {
            "id": "1104011",
            "injury": -30,
            "injury_chance": 1
        }
    },
    "1104021": {
        "id": "1104021",
        "weight": 1,
        "price": 16.5,
        "value": 16.15383871468867,
        "effect_medicine": {
            "id": "1104021",
            "infect": -20,
            "infect_chance": 1
        }
    },
    "1104032": {
        "id": "1104032",
        "weight": 1,
        "price": 31,
        "value": 30.0731189840807,
        "effect_medicine": {
            "id": "1104032",
            "infect": -100,
            "infect_chance": 1,
            "hp": -150,
            "hp_chance": 0.5
        }
    },
    "1104043": {
        "id": "1104043",
        "weight": 1,
        "price": 60,
        "value": 60,
        "effect_medicine": {
            "id": "1104043",
            "infect": -100,
            "infect_chance": 1
        }
    },
    "1105011": {
        "id": "1105011",
        "weight": 0,
        "price": 2,
        "value": 2
    },
    "1105022": {
        "id": "1105022",
        "weight": 1,
        "price": 3.75,
        "value": 3.6694572875325524
    },
    "1105033": {
        "id": "1105033",
        "weight": 1,
        "price": 11.5,
        "value": 11.248722605665916
    },
    "1105042": {
        "id": "1105042",
        "weight": 1,
        "price": 1,
        "value": 1
    },
    "1105051": {
        "id": "1105051",
        "weight": 1,
        "price": 0.75,
        "value": 0.6994851874999999
    },
    "1106013": {
        "id": "1106013",
        "weight": 12,
        "price": 60,
        "value": 60
    },
    "1106014": {
        "id": "1106014",
        "weight": 1,
        "price": 2,
        "value": 2
    },
    "1106054": {
        "id": "1106054",
        "weight": 4,
        "price": 100,
        "value": 100
    },
    "1107012": {
        "id": "1107012",
        "weight": 1,
        "price": 22,
        "value": 22,
        "effect_buff": {
            "id": "1107012",
            "effect": 1,
            "effectType": 1,
            "value": 60,
            "lastTime": 72
        }
    },
    "1107022": {
        "id": "1107022",
        "weight": 1,
        "price": 45,
        "value": 45,
        "effect_buff": {
            "id": "1107022",
            "effect": 2,
            "effectType": 2,
            "value": 0,
            "lastTime": 72
        }
    },
    "1107032": {
        "id": "1107032",
        "weight": 1,
        "price": 22,
        "value": 22,
        "effect_buff": {
            "id": "1107032",
            "effect": 3,
            "effectType": 2,
            "value": 0,
            "lastTime": 72
        }
    },
    "1107042": {
        "id": "1107042",
        "weight": 1,
        "price": 28,
        "value": 28,
        "effect_buff": {
            "id": "1107042",
            "effect": 4,
            "effectType": 2,
            "value": 0,
            "lastTime": 72
        }
    },
    "1107052": {
        "id": "1107052",
        "weight": 1,
        "price": 24,
        "value": 24,
        "effect_buff": {
            "id": "1107052",
            "effect": 5,
            "effectType": 2,
            "value": 0,
            "lastTime": 72
        }
    },
    "1301011": {
        "id": "1301011",
        "weight": 1,
        "price": 15,
        "value": 9.999,
        "effect_weapon": {
            "id": "1301011",
            "atk": 0,
            "atkCD": 1,
            "range": 4,
            "bulletMin": 1,
            "bulletMax": 1,
            "bulletNum": 10,
            "reloadCD": 1,
            "precise": 0.55,
            "dtPrecise": 0.05,
            "deathHit": 0.05,
            "dtDeathHit": 0.01,
            "brokenProbability": 0.065
        }
    },
    "1301022": {
        "id": "1301022",
        "weight": 4,
        "price": 25.5,
        "value": 16.968,
        "effect_weapon": {
            "id": "1301022",
            "atk": 0,
            "atkCD": 2,
            "range": 5,
            "bulletMin": 1,
            "bulletMax": 2,
            "bulletNum": 6,
            "reloadCD": 0.5,
            "precise": 0.65,
            "dtPrecise": 0,
            "deathHit": 0.1,
            "dtDeathHit": 0.05,
            "brokenProbability": 0.065
        }
    },
    "1301033": {
        "id": "1301033",
        "weight": 6,
        "price": 50,
        "value": 32.825,
        "effect_weapon": {
            "id": "1301033",
            "atk": 0,
            "atkCD": 1,
            "range": 5,
            "bulletMin": 3,
            "bulletMax": 3,
            "bulletNum": 30,
            "reloadCD": 1,
            "precise": 0.6,
            "dtPrecise": 0.01,
            "deathHit": 0.1,
            "dtDeathHit": 0.05,
            "brokenProbability": 0.065
        }
    },
    "1301041": {
        "id": "1301041",
        "weight": 2,
        "price": 17,
        "value": 12,
        "effect_weapon": {
            "id": "1301041",
            "atk": 0,
            "atkCD": 1,
            "range": 5,
            "bulletMin": 1,
            "bulletMax": 1,
            "bulletNum": 6,
            "reloadCD": 1,
            "precise": 0.55,
            "dtPrecise": 0.05,
            "deathHit": 0.1,
            "dtDeathHit": 0.03,
            "brokenProbability": 0.07
        }
    },
    "1301052": {
        "id": "1301052",
        "weight": 5,
        "price": 28,
        "value": 18,
        "effect_weapon": {
            "id": "1301052",
            "atk": 0,
            "atkCD": 2,
            "range": 5,
            "bulletMin": 1,
            "bulletMax": 2,
            "bulletNum": 5,
            "reloadCD": 0.5,
            "precise": 0.65,
            "dtPrecise": 0,
            "deathHit": 0.2,
            "dtDeathHit": 0.05,
            "brokenProbability": 0.07
        }
    },
    "1301063": {
        "id": "1301063",
        "weight": 6,
        "price": 55,
        "value": 35,
        "effect_weapon": {
            "id": "1301063",
            "atk": 0,
            "atkCD": 1,
            "range": 5,
            "bulletMin": 3,
            "bulletMax": 3,
            "bulletNum": 30,
            "reloadCD": 1,
            "precise": 0.6,
            "dtPrecise": 0.01,
            "deathHit": 0.1,
            "dtDeathHit": 0.05,
            "brokenProbability": 0.07
        }
    },
    "1301071": {
        "id": "1301071",
        "weight": 3,
        "price": 30,
        "value": 30,
        "effect_weapon": {
            "id": "1301071",
            "atk": 60,
            "atkCD": 1,
            "range": 3,
            "bulletMin": 1,
            "bulletMax": 1,
            "bulletNum": 30,
            "reloadCD": 1,
            "precise": 0.8,
            "dtPrecise": 0,
            "deathHit": 0.1,
            "dtDeathHit": 0.05,
            "brokenProbability": 0.04
        }
    },
    "1301082": {
        "id": "1301082",
        "weight": 10,
        "price": 60,
        "value": 60,
        "effect_weapon": {
            "id": "1301082",
            "atk": 110,
            "atkCD": 2,
            "range": 4,
            "bulletMin": 1,
            "bulletMax": 1,
            "bulletNum": 30,
            "reloadCD": 1,
            "precise": 0.8,
            "dtPrecise": 0,
            "deathHit": 0.1,
            "dtDeathHit": 0.05,
            "brokenProbability": 0.04
        }
    },
    "1301091": {
        "id": "1301091",
        "weight": 6,
        "price": 40,
        "value": 40,
        "effect_weapon": {
            "id": "1301091",
            "atk": 25,
            "atkCD": 1,
            "range": 19,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 0.2,
            "precise": 0,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0.08
        }
    },
    "1302011": {
        "id": "1302011",
        "weight": 2,
        "price": 3.5,
        "value": 3.3165,
        "effect_tool": {
            "id": "1302011",
            "workingTime": 10
        },
        "effect_weapon": {
            "id": "1302011",
            "atk": 40,
            "atkCD": 1,
            "range": 0,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 1,
            "precise": 1,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0.05
        }
    },
    "1302021": {
        "id": "1302021",
        "weight": 2,
        "price": 2.25,
        "value": 2.211,
        "effect_tool": {
            "id": "1302021",
            "workingTime": 20
        },
        "effect_weapon": {
            "id": "1302021",
            "atk": 40,
            "atkCD": 1,
            "range": 0,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 1,
            "precise": 1,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0.05
        }
    },
    "1302032": {
        "id": "1302032",
        "weight": 3,
        "price": 11,
        "value": 10.908,
        "effect_weapon": {
            "id": "1302032",
            "atk": 50,
            "atkCD": 1,
            "range": 0,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 1,
            "precise": 1,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0.05
        }
    },
    "1302043": {
        "id": "1302043",
        "weight": 6,
        "price": 50,
        "value": 50,
        "effect_tool": {
            "id": "1302021",
            "workingTime": 5
        },
        "effect_weapon": {
            "id": "1302043",
            "atk": 100,
            "atkCD": 1.5,
            "range": 0,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 0.6,
            "precise": 1,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0.04
        }
    },
    "1303012": {
        "id": "1303012",
        "weight": 1,
        "price": 4,
        "value": 4,
        "effect_weapon": {
            "id": "1303012",
            "atk": 50,
            "atkCD": 5,
            "range": 5,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 0.2,
            "precise": 0,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0
        }
    },
    "1303022": {
        "id": "1303022",
        "weight": 1,
        "price": 8,
        "value": 8,
        "effect_weapon": {
            "id": "1303022",
            "atk": 3,
            "atkCD": 5,
            "range": 5,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 0.2,
            "precise": 0,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0
        }
    },
    "1303033": {
        "id": "1303033",
        "weight": 1,
        "price": 18,
        "value": 18,
        "effect_weapon": {
            "id": "1303033",
            "atk": 100,
            "atkCD": 5,
            "range": 5,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 0.2,
            "precise": 0,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0
        }
    },
    "1303044": {
        "id": "1303044",
        "weight": 1,
        "price": 28,
        "value": 28,
        "effect_weapon": {
            "id": "1303044",
            "atk": 160,
            "atkCD": 5,
            "range": 5,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 0.2,
            "precise": 0,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0
        }
    },
    "1304012": {
        "id": "1304012",
        "weight": 2,
        "price": 8.5,
        "value": 8.442,
        "effect_arm": {
            "id": "1304012",
            "def": 3,
            "brokenProbability": 0.08
        }
    },
    "1304023": {
        "id": "1304023",
        "weight": 3,
        "price": 18.5,
        "value": 18.290999999999997,
        "effect_arm": {
            "id": "1304023",
            "def": 5,
            "brokenProbability": 0.06
        }
    },
    "1306001": {
        "id": "1306001",
        "weight": 1,
        "price": 8,
        "value": 7.878000000000001
    },
    "1305011": {
        "id": "1305011",
        "weight": 0,
        "price": 0.9,
        "value": 0.8888,
        "effect_weapon": {
            "id": "1305011",
            "atk": 50,
            "atkCD": 0,
            "range": 0,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 0,
            "precise": 0,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0
        }
    },
    "1305012": {
        "id": "1305012",
        "weight": 0,
        "price": 0.7,
        "value": 0.688888,
        "effect_weapon": {
            "id": "1305011",
            "atk": 50,
            "atkCD": 0,
            "range": 0,
            "bulletMin": 0,
            "bulletMax": 0,
            "bulletNum": 0,
            "reloadCD": 0,
            "precise": 0,
            "dtPrecise": 0,
            "deathHit": 0,
            "dtDeathHit": 0,
            "brokenProbability": 0
        }
    },
    "1305023": {
        "id": "1305023",
        "weight": 1,
        "price": 13,
        "value": 13.13
    },
    "1305024": {
        "id": "1305024",
        "weight": 2,
        "price": 38,
        "value": 36.763999999999996
    },
    "1305034": {
        "id": "1305034",
        "weight": 16,
        "price": 64,
        "value": 62.374777777777774
    },
    "1305053": {
        "id": "1305053",
        "weight": 2,
        "price": 24,
        "value": 23.216666666666664
    },
    "1305064": {
        "id": "1305064",
        "weight": 4,
        "price": 48,
        "value": 46.383444444444443
    },
    "1305075": {
        "id": "1305075",
        "weight": 4,
        "price": 4,
        "value": 3.333333
    }
} as const
